import {action, computed, observable} from '@api'
import {PDFTemplateName} from '@modules/pdf'
import {CatalogInstanceChildStore} from '@stores/catalog/CatalogInstanceChildStore'
import {CatalogStore} from '@stores/catalog/CatalogStore'
import {_} from '@api'
import {DeploymentPdfConfig} from '@stores/config'
import {globalStores} from '@stores/index'
import {defaultPDFConfig} from '@stores/ui'

export class CatalogPDFStore extends CatalogInstanceChildStore {
  constructor(public catalog: CatalogStore) {
    super(catalog)
  }

  @computed get arePdfTemplatesAvailable() {
    return !this.isGlobalStore && !_.isEmpty(this.availableTemplates)
  }

  @computed get serverTemplatesById() { return new Set(this.config.templates) }

  /**
   * Templates available to the user based on current catalog state
   */
  @computed get availableTemplates() : Set<PDFTemplateName> {
    const {config: {templates}, serverTemplatesById, catalog: { isShowingAssortment, isGroupedView}} = this,
      r: Array<PDFTemplateName> = []

    isShowingAssortment && r.push('assortment')
    isGroupedView && r.push('catalogItems_grouped')
    r.push('catalogItems')

    return new Set<string>(_.isEmpty(templates) ? r : r.filter(v => serverTemplatesById.has(v)))
  }

  @computed get config(): DeploymentPdfConfig {
    const {workspaces: {pdfConfig}} = this
    Object.keys(defaultPDFConfig).map(k => {
      if (!!_.get(pdfConfig, k)) {
        if (defaultPDFConfig[k] && Array.isArray(defaultPDFConfig[k]) && Array.isArray(this.workspaces.pdfConfig[k])) {
          defaultPDFConfig[k].push(...this.workspaces.pdfConfig[k])
        } else if (_.isString(defaultPDFConfig[k])) {
          defaultPDFConfig[k] = this.workspaces.pdfConfig[k]
        } else {
          _.merge(defaultPDFConfig[k], this.workspaces.pdfConfig[k])
        }
      }
    })

    return defaultPDFConfig
  }

  get settings() { return this.catalog.settings}
  get settingsPdf() { return this.settings.pdf}

  @computed get isClientPdfAvailable() {
    const {stores:{userSettings}} = this
    return !this.catalog.hasLoadedSettings ? false : (this.workspaces?.deploymentConfig?.settings?.pdf?.target !== 'server' && (!DEBUG || !userSettings.serverPDF))
  }

  get userSettings() { return this.stores.userSettings}

  @computed get isServerPdfAvailable() {
    return !this.catalog.hasLoadedSettings ? false : (((DEBUG && this.userSettings?.serverPDF) || this.workspaces?.deploymentConfig?.settings?.pdf?.target === 'server') && (this.arePdfTemplatesAvailable || this.stores.isGlobalStore))
  }

  @computed get isShowingClientPDF() {
    return !this.catalog.hasLoadedSettings ? false : this.settings.viewMode === 'pdf'
  }

  set isShowingClientPDF(value: boolean) {
    if (value != this.isShowingClientPDF) {
      this.toggleShowPdf()
    }
  }

  @observable isFrozen = false

  get pdf() { return this.stores.pdf ?? globalStores?.pdf}

  @action toggleShowPdf = () => {
    const {isShowingClientPDF, pdf, stores: {sidebar: {right}}} = this

    isShowingClientPDF && (pdf.document = null)
    this.settings.viewMode = isShowingClientPDF ? 'card' : 'pdf'
    right.open = !isShowingClientPDF
  }

  @action onSwitchToPdfView = () => {
    this.isShowingClientPDF = true
  }

  @action client_onTogglePdfView = () => {
    const {catalog: {onSwitchToCardView}, isShowingClientPDF, onSwitchToPdfView} = this
    if (isShowingClientPDF) {
      onSwitchToCardView()
    } else {
      onSwitchToPdfView()
    }
  }
}


// WEBPACK FOOTER //
// ./src/stores/catalog/CatalogPDFStore.ts